<template>
  <div class="not-authorized">
    <h1 class="title">Not Authorized</h1>
    <p class="message">You do not have permission to access this page.</p>
    <router-link to="/" class="home-link">Go back to Home</router-link>
  </div>
</template>
<script>
export default {
  name: 'NotAuthorized',
};
</script>
<style scoped>
.not-authorized {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #f8f9fa;
  text-align: center;
  padding: 20px;
}

.title {
  font-size: 2rem;
  color: #dc3545;
  margin-bottom: 20px;
}

.message {
  font-size: 1.25rem;
  color: #6c757d; 
  margin-bottom: 20px;
}

.home-link {
  font-size: 1rem;
  color: #007bff; 
  text-decoration: none;
}

.home-link:hover {
  text-decoration: underline;
}
</style>
